import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TrendingUp, ChevronRight } from "lucide-react";
import { Card } from "./ui/card";
import { Link } from "react-router-dom";

interface NewsItem {
  id: number;
  information_title: string;
  tag: string;
  release_time: string;
}

export function CompanyCulture() {
  const navigate = useNavigate();
  const [newsItems, setNewsItems] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const resp = await fetch('/api/public/information/company-culture');
      const result = await resp.json();
      if (result.ok && result.data) {
        // 只取前3条
        setNewsItems(result.data.slice(0, 3));
      }
    } catch (err) {
      console.error('获取企业新闻列表失败:', err);
    } finally {
      setLoading(false);
    }
  };

  // 格式化日期时间
  const formatDateTime = (dateStr: string) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).replace(/\//g, '-');
  };

  // 点击文章跳转到详情页
  const handleClick = (id: number) => {
    navigate(`/company-culture/${id}`);
  };

  return (
    <Card className="border border-gray-200 shadow-lg">
      <div className="p-6">
        {/* Title section */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-3">
            <div className="bg-[#003c8c] w-1 h-6 rounded"></div>
            <h3 className="text-gray-800">企业新闻</h3>
          </div>
          <Link
            to="/company-culture"
            className="text-[#003c8c] hover:text-[#0050b8] flex items-center text-sm transition-colors"
          >
            查看更多
            <ChevronRight className="w-4 h-4 ml-1" />
          </Link>
        </div>

        {/* News list */}
        {loading ? (
          <div className="text-center py-8 text-gray-400">
            <p>加载中...</p>
          </div>
        ) : newsItems.length > 0 ? (
          <div className="divide-y divide-gray-200">
            {newsItems.map((item) => (
              <div
                key={item.id}
                className="py-4 hover:bg-gray-50 transition-colors cursor-pointer group"
                onClick={() => handleClick(item.id)}
              >
                <div className="flex items-start gap-3">
                  <TrendingUp className="w-4 h-4 text-[#003c8c] mt-1 flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <h4 className="text-gray-800 group-hover:text-[#003c8c] transition-colors md:line-clamp-2 truncate">
                      {item.information_title}
                    </h4>
                  </div>
                  <span className="hidden md:inline text-xs text-gray-400 whitespace-nowrap flex-shrink-0 mt-1">
                    {formatDateTime(item.release_time)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-400">
            <TrendingUp className="w-10 h-10 mx-auto mb-2 opacity-50" />
            <p>暂无企业新闻</p>
          </div>
        )}
      </div>
    </Card>
  );
}

